export enum ForgetFlowStepEnum {
    userName = 1,
    verification,
    setPassword
}

export enum SetPassFlowStepEnum {
    reqOtp = 1,
    verification,
    setPassword
}
